import React, { useState, useContext, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import PhoneLogin from './phoneLogin'
// import PhoneSignup from './phoneSignup'
import { getProfile, signup } from '../../../services/migrantService'
import { AuthContext, UserType } from '../../../contexts/authContext'
import {
  MigrantContext,
  MigrantContextInterface
} from '../../../contexts/migrantContext'
import { Consumer } from '../../../models/Consumer'
import firebase from 'firebase'
import { ProviderId } from '../../../config/enums'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { toast } from 'react-toastify'
import { /*useHistory,*/ useLocation } from 'react-router-dom'
import Layout from '../../common/layout/layout'
import styles from './index.module.css'

function Onboarding() {
  const authContext = useContext(AuthContext)
  const migrantContext = useContext(MigrantContext)
  // const history = useHistory()

  const handleSocialLogInSuccess = (
    authResult: any,
    migrantContext: MigrantContextInterface
  ) => {
    console.info('authResult:', authResult)
    getProfile(authResult.user.uid)
      .then(profile => {
        if (profile) {
          // user is already signed up, do nothing
          console.info('Fetched migrant profile:', profile)
          return profile
        }

        // user is not signed up yet, do a signup
        console.warn("Migrant profile doesn't exists yet. Signing up...")
        let firstName = 'First Name',
          lastName = 'Last Name',
          avatarUrl: string | undefined

        const providerId = authResult.additionalUserInfo.providerId
        const pProfile = authResult.additionalUserInfo.profile

        if (providerId === ProviderId.google) {
          firstName = pProfile.given_name as string
          lastName = pProfile.family_name as string
          avatarUrl = pProfile.picture as string
        } else if (providerId === ProviderId.facebook) {
          firstName = pProfile.first_name as string
          lastName = pProfile.last_name as string
          avatarUrl = pProfile.picture.data.url as string
        } else {
          console.warn('First and last name not found from user info')
        }

        return signup(firstName, lastName, avatarUrl)
      })
      .then((profile: Consumer | null) => {
        if (profile) {
          migrantContext.setProfile(profile as Consumer)
        } else {
          throw new Error()
        }
      })
      .catch(err => {
        console.error('Social login error:', err)
        const message = friendlyMessageFor(err.code as string)
        toast.error(message, { autoClose: false })
      })
  }

  // const handleSocialSignUpSuccess = (
  //   authResult: any,
  //   migrantContext: MigrantContextInterface
  // ) => {
  //   console.info('authResult:', authResult)
  //   getProfile(authResult.user.uid)
  //     .then(profile => {
  //       if (profile) {
  //         // user is already signed up, do nothing
  //         console.info('Fetched migrant profile:', profile)
  //         return profile
  //       }

  //       // user is not signed up yet, do a signup
  //       console.warn("Migrant profile doesn't exists yet. Signing up...")
  //       let firstName = 'First Name',
  //         lastName = 'Last Name',
  //         avatarUrl: string | undefined

  //       const providerId = authResult.additionalUserInfo.providerId
  //       const pProfile = authResult.additionalUserInfo.profile

  //       if (providerId === ProviderId.google) {
  //         firstName = pProfile.given_name as string
  //         lastName = pProfile.family_name as string
  //         avatarUrl = pProfile.picture as string
  //       } else if (providerId === ProviderId.facebook) {
  //         firstName = pProfile.first_name as string
  //         lastName = pProfile.last_name as string
  //         avatarUrl = pProfile.picture.data.url as string
  //       } else {
  //         console.warn('First and last name not found from user info')
  //       }

  //       return signup(firstName, lastName, avatarUrl)
  //     })
  //     .then((profile: Consumer | null) => {
  //       if (profile) {
  //         migrantContext.setProfile(profile as Consumer)
  //         history.push('/onboarding/homecountry')
  //       } else {
  //         throw new Error()
  //       }
  //     })
  //     .catch(err => {
  //       console.error('Social login error:', err)
  //       const message = friendlyMessageFor(err.code as string)
  //       toast.error(message, { autoClose: false })
  //     })
  // }

  if (authContext?.userType !== UserType.migrant) {
    authContext?.setUserType(UserType.migrant)
  }

  // Facebook/Google SignIn config
  const uiConfig: firebaseui.auth.Config = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID
    ],
    callbacks: {
      signInSuccessWithAuthResult: authResult => {
        handleSocialLogInSuccess(
          authResult,
          migrantContext as MigrantContextInterface
        )
        return false
      }
    }
  }

  // const uiConfigSignUp: firebaseui.auth.Config = {
  //   signInFlow: 'popup',
  //   signInOptions: [
  //     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  //     firebase.auth.FacebookAuthProvider.PROVIDER_ID
  //   ],
  //   callbacks: {
  //     signInSuccessWithAuthResult: authResult => {
  //       handleSocialSignUpSuccess(
  //         authResult,
  //         migrantContext as MigrantContextInterface
  //       )
  //       return false
  //     }
  //   }
  // }

  // Logic for sliding sign in and signup form
  const [loginExpanded, setLoginExpanded] = useState(true)
  const [, /*signUpExpanded*/ setSignUpExpanded] = useState(false)

  const switchOnboarding = () => {
    if (loginExpanded) {
      setLoginExpanded(false)
      setSignUpExpanded(true)
    } else {
      setLoginExpanded(true)
      setSignUpExpanded(false)
    }
  }

  const search = useLocation().search

  useEffect(() => {
    const query = new URLSearchParams(search)
    if (query.get('action') === 'signup') {
      setLoginExpanded(false)
      setSignUpExpanded(true)
    } else {
      setLoginExpanded(true)
      setSignUpExpanded(false)
    }
  }, [search])

  return (
    <Layout>
      <Row>
        <Col md={8} lg={5} className="mx-auto">
          <h1 className="pageTitle">Welcome!</h1>
          {/* <PhoneSignup
            expanded={signUpExpanded}
            onClick={switchOnboarding}
            uiConfig={uiConfigSignUp}
            styles={styles}
          /> */}
          <PhoneLogin
            expanded={loginExpanded}
            onClick={switchOnboarding}
            uiConfig={uiConfig}
            styles={styles}
          />
        </Col>
      </Row>
    </Layout>
  )
}

export default Onboarding
